<script setup>
import { h, isVNode } from 'vue';

const props = defineProps({
  icon: { type: [String, Object, Function], required: true },
});

const isImagePath = (iconValue) => {
  return typeof iconValue === 'string' && iconValue.startsWith('/assets/');
};

const renderIcon = () => {
  if (!props.icon) return null;
  if (typeof props.icon === 'function' || isVNode(props.icon)) {
    return props.icon;
  }

  // Check if icon is an image path
  if (isImagePath(props.icon)) {
    return h('img', {
      src: props.icon,
      class: 'inline-block w-5 h-5 object-contain',
      alt: 'Channel icon'
    });
  }

  return h('span', { class: props.icon });
};
</script>

<template>
  <component :is="renderIcon" />
</template>
